import React from "react";

import styles from "./LoadingSkeleton.module.css";

interface LoadingSkeletonProps {
  className?: string;
}

const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({ className }) => (
  <div
    className={`u-min-h-screen u-bg-brand-300 u-flex u-items-center u-justify-center ${className || ""}`}
    data-testid="loading-skeleton"
  >
    <div className={styles.container}>
      <div className={styles.titleSkeleton} />
      <div className={styles.buttonSkeleton} />
    </div>
  </div>
);

export default LoadingSkeleton;
